<template>
    <div class="Pricing">
        <div class="Price-Wrap">
            <!-- Lite Plan -->
            <Card
                class="Price-Card Price-Card--lite"
                :class="{ 'current-plan': planType === 'lite' }"
            >
                <div class="PlanLabel">
                    <i class="ri-flashlight-line"></i>
                    <span>Lite</span>
                </div>
                <div class="PlanDescription">TSE-konform und rechtssicher starten</div>
                <h3 class="PlanPrice">
                    <div>10,00€</div>
                </h3>
                <div class="PriceInfo">pro Monat / pro Fahrzeug</div>
                <ul class="FeatureList">
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-database-2-line"></i></span>
                        <span>Datenspeicherung in Echtzeit</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-sim-card-line"></i></span>
                        <span>SIM-Karte inklusive</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"
                            ><i class="ri-shield-keyhole-line"></i
                        ></span>
                        <span>TSE Gateway Gebühren inklusive</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-team-line"></i></span>
                        <span>Mitarbeiterverwaltung</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"
                            ><i class="ri-calendar-check-line"></i
                        ></span>
                        <span>Schichtmanagement</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-file-edit-line"></i></span>
                        <span>Manuelle TSE Kassenmeldung ans Finanzamt</span>
                    </li>
                </ul>
                <div class="PlanCta">
                    <Button
                        v-if="planType === 'lite'"
                        variant="outline"
                        disabled
                        class="Upgrade-Button"
                    >
                        Aktueller Tarif
                    </Button>
                    <Button
                        v-else
                        variant="outline"
                        class="Upgrade-Button"
                        @onClick="handleUpgrade('lite')"
                    >
                        {{ getButtonText('lite') }}
                    </Button>
                </div>
            </Card>

            <!-- Basic Plan -->
            <Card
                class="Price-Card Price-Card--highlight Price-Card--premium"
                :class="{ 'current-plan': planType === 'basic' }"
            >
                <div
                    class="PopularBadge"
                    v-tooltip="'98% unserer Kunden entscheiden sich für den Basic Tarif'"
                >
                    <i class="ri-fire-fill"></i>
                    <span>Bestseller</span>
                </div>
                <div class="PlanLabel">
                    <i class="ri-medal-line"></i>
                    <span>Basic</span>
                </div>
                <div class="PlanDescription">Die bewährte Lösung für wachsende Flotten</div>
                <h3 class="PlanPrice">
                    <div>16,00€</div>
                </h3>
                <div class="PriceInfo">pro Monat / pro Fahrzeug</div>
                <ul class="FeatureList">
                    <li class="FeatureHighlight">
                        <span class="FeatureIconCircle"
                            ><i class="ri-checkbox-circle-line"></i
                        ></span>
                        <span><strong>Alles in Lite</strong></span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-magic-line"></i></span>
                        <span><strong>Automatische TSE Kassenmeldung ans Finanzamt</strong></span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-file-list-3-line"></i></span>
                        <span>Betriebsnachweise</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-time-line"></i></span>
                        <span>Arbeitszeitnachweise</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-bar-chart-line"></i></span>
                        <span>Analyse & Reporting</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-alarm-line"></i></span>
                        <span>
                            Erinnerungen
                            <span class="FeatureSubtext">Für TÜV, P-Schein, Eichung etc</span>
                        </span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-smartphone-line"></i></span>
                        <span>
                            Driver App
                            <span class="FeatureSubtext"
                                >Pausenverwaltung, Fahrtmarkierungen, Umsatz-Tracking, MyPOS
                                Integration</span
                            >
                        </span>
                    </li>
                </ul>
                <MenuDropdown
                    title="Ihr Sparpotenzial prüfen"
                    :items="basicDiscountItems"
                    :open-upward="true"
                    class="theme-dark"
                >
                    <template #tooltip="{ item }">
                        <span>{{ item.tooltip }}</span>
                    </template>
                </MenuDropdown>
                <div class="PlanCta">
                    <Button
                        v-if="planType === 'basic'"
                        variant="outline"
                        disabled
                        class="Upgrade-Button"
                    >
                        Aktueller Tarif
                    </Button>
                    <Button
                        v-else
                        class="Upgrade-Button Upgrade-Button--primary"
                        @onClick="handleUpgrade('basic')"
                    >
                        {{ getButtonText('basic') }}
                    </Button>
                </div>
            </Card>

            <!-- Premium Plan -->
            <Card
                v-if="false"
                class="Price-Card Price-Card--premium"
                :class="{ 'current-plan': planType === 'premium' }"
            >
                <div class="PlanLabel">
                    <i class="ri-vip-crown-line"></i>
                    <span>Premium</span>
                </div>
                <div class="PlanDescription">
                    Vollständige Lösung für professionelle Fahrzeugunternehmen
                </div>
                <h3 class="PlanPrice">
                    <div>29,00€</div>
                </h3>
                <div class="PriceInfo">pro Monat / pro Fahrzeug</div>
                <ul class="FeatureList">
                    <li class="FeatureHighlight">
                        <span class="FeatureIconCircle"
                            ><i class="ri-checkbox-circle-line"></i
                        ></span>
                        <span><strong>Alles in Basic</strong></span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-timeline-view"></i></span>
                        <span>Schichtplanner</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-links-line"></i></span>
                        <span>
                            Automatische Fahrtzuordnung
                            <span class="FeatureSubtext">Bolt, Uber, FreeNow</span>
                        </span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-calculator-line"></i></span>
                        <span>Rücklagenrechner</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"
                            ><i class="ri-calendar-event-line"></i
                        ></span>
                        <span>Kalender</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-tools-line"></i></span>
                        <span>Fahrzeugwartung</span>
                    </li>
                    <li>
                        <span class="FeatureIconCircle"><i class="ri-book-open-line"></i></span>
                        <span>Kassenbuch</span>
                    </li>
                </ul>
                <MenuDropdown
                    title="Rabatte anzeigen"
                    :items="premiumDiscountItems"
                    :open-upward="true"
                    class="theme-dark"
                >
                    <template #tooltip="{ item }">
                        <span>{{ item.tooltip }}</span>
                    </template>
                </MenuDropdown>
                <div class="PlanCta">
                    <Button
                        v-if="planType === 'premium'"
                        variant="outline"
                        disabled
                        class="Upgrade-Button"
                    >
                        Aktueller Plan
                    </Button>
                    <Button
                        v-else
                        class="Upgrade-Button Upgrade-Button--premium"
                        @onClick="handleUpgrade('premium')"
                    >
                        {{ getButtonText('premium') }}
                    </Button>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
import Card from '@/components/Card.vue';
import Button from '@/components/widgets/Button.vue';
import MenuDropdown from '@/components/MenuDropdown.vue';

export default {
    name: 'Pricing',
    components: {
        Card,
        Button,
        MenuDropdown,
    },
    props: {
        planType: {
            type: String,
            default: 'lite',
        },
        isMarketing: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        basicDiscountItems() {
            return [
                {
                    label: 'Einzelfahrer: 3€ Rabatt',
                    tooltip: `Bei 3€ Rabatt zahlen Sie 13,00€ pro Fahrzeug und Monat`,
                },
                {
                    label: 'ab 10 Autos: 5% Rabatt',
                    tooltip: `Bei 5% Rabatt zahlen Sie 15,20€ pro Fahrzeug und Monat`,
                },
                {
                    label: 'ab 20 Autos: 10% Rabatt',
                    tooltip: `Bei 10% Rabatt zahlen Sie 14,40€ pro Fahrzeug und Monat`,
                },
            ];
        },
        premiumDiscountItems() {
            return [
                {
                    label: 'Einzelfahrer: 3€ Rabatt',
                    tooltip: `Bei 3€ Rabatt zahlen Sie 26,00€ pro Fahrzeug und Monat`,
                },
                {
                    label: 'ab 10 Autos: 5% Rabatt',
                    tooltip: `Bei 5% Rabatt zahlen Sie 27,55€ pro Fahrzeug und Monat`,
                },
                {
                    label: 'ab 20 Autos: 10% Rabatt',
                    tooltip: `Bei 10% Rabatt zahlen Sie 26,10€ pro Fahrzeug und Monat`,
                },
            ];
        },
    },
    methods: {
        handleUpgrade(targetPlan) {
            if (this.isMarketing) {
                this.$emit('onUpgrade', targetPlan);
            } else {
                this.handlePlanUpgrade(targetPlan);
            }
        },
        handlePlanUpgrade(targetPlan) {
            const planNames = {
                lite: 'Lite',
                basic: 'Basic',
                premium: 'Premium',
            };

            const currentPlanName = planNames[this.planType] || 'Unbekannt';
            const targetPlanName = planNames[targetPlan] || 'Unbekannt';

            const action =
                targetPlan === 'lite' || (this.planType === 'premium' && targetPlan !== 'premium')
                    ? 'Downgrade'
                    : 'Upgrade';

            const subject = encodeURIComponent(
                `${action} Anfrage: Von ${currentPlanName} zu ${targetPlanName}`,
            );
            const body = encodeURIComponent(
                `Hallo TaxiFusion Team,\n\n` +
                    `ich möchte meinen Tarif ändern:\n\n` +
                    `Aktueller Tarif: ${currentPlanName}\n` +
                    `Gewünschter Tarif: ${targetPlanName}\n\n` +
                    `Bitte kontaktieren Sie mich, um den Wechsel zu besprechen.\n\n` +
                    `Vielen Dank!`,
            );

            const mailtoLink = `mailto:support@taxifusion.de?subject=${subject}&body=${body}`;
            window.location.href = mailtoLink;
        },
        getButtonText(plan) {
            if (this.isMarketing) {
                const planNames = {
                    lite: 'Mit Lite starten',
                    basic: 'Mit Basic starten',
                    premium: 'Mit Premium starten',
                };
                return planNames[plan];
            } else {
                const planNames = {
                    lite: 'Zu Lite wechseln',
                    basic: 'Zu Basic upgraden',
                    premium: 'Zu Premium upgraden',
                };
                return planNames[plan];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.Pricing {
    width: 100%;
}

.Price-Wrap {
    display: flex;
    column-gap: 30px;
    justify-content: center;

    @media (max-width: $breakpoint-tablet-landscape) {
        flex-direction: column;
        align-items: center;
        row-gap: 30px;
    }
}

.Price-Card {
    flex: 1;
    max-width: 350px;
    padding: 16px 20px;
    position: relative;
    transition: all 0.3s ease;
    border-radius: 10px;
    border: 0.5px solid var(--color-border-light);
    display: flex;
    flex-direction: column;
    overflow: visible;
    z-index: 1;

    &:hover {
        box-shadow: 0 12px 30px rgba(30, 34, 90, 0.15);
        border-color: var(--color-blue-light);
    }

    &.current-plan {
        border: 0.5px solid var(--color-blue);

        .PlanLabel {
            color: var(--color-blue);
        }
    }

    &.Price-Card--lite {
        background: transparent;
        border: 1px dashed var(--color-border);

        &:hover {
            background: var(--color-white);
            border-style: solid;
        }

        .FeatureIconCircle {
            background: var(--color-row-alternate);
            color: var(--color-text-gray);
        }
    }

    &.Price-Card--highlight {
        border: 0.5px solid var(--color-border-light);
        position: relative;
        z-index: 2;

        .PlanLabel {
            color: var(--color-blue-dark);
        }
    }

    &.Price-Card--premium {
        background: linear-gradient(
            to bottom,
            var(--color-blue-dark),
            var(--color-blue-darker)
        ) !important;
        border: 0.5px solid var(--color-blue-dark);
        color: var(--color-text-white);
        position: relative;
        z-index: 1;

        .PlanLabel,
        .PlanPrice {
            color: var(--color-text-white);
        }

        .PlanLabel i {
            color: var(--color-text-white);
        }

        .PlanDescription,
        .PriceInfo {
            color: rgba(255, 255, 255, 0.7);
        }

        .FeatureList li {
            color: rgba(255, 255, 255, 0.9);

            .FeatureSubtext {
                color: rgba(255, 255, 255, 0.7);
            }

            &.FeatureHighlight {
                background: rgba(255, 255, 255, 0.1);
                border-radius: 6px;

                span {
                    color: rgba(255, 255, 255, 1);
                    font-weight: 700;
                }
            }
        }

        .FeatureIconCircle {
            background: rgba(255, 255, 255, 0.1);
            color: var(--color-text-white);
        }

        .Upgrade-Button {
            color: var(--color-text-white) !important;
            border-color: rgba(255, 255, 255, 0.3) !important;

            &:hover {
                background: rgba(255, 255, 255, 0.1) !important;
                border-color: rgba(255, 255, 255, 0.5) !important;
            }

            &:disabled {
                color: rgba(255, 255, 255, 0.7) !important;
                border-color: rgba(255, 255, 255, 0.2) !important;
                opacity: 1 !important;
            }
        }

        &.current-plan {
            border: 0.5px solid var(--color-blue);
            background: var(--color-blue-darker);
        }
    }

    @media (max-width: $breakpoint-tablet-landscape) {
        max-width: 100%;
        width: 100%;
        min-height: auto;
    }
}

.PopularBadge {
    position: absolute;
    top: 10px;
    right: 10px;
    background: linear-gradient(135deg, #ffe89e 0%, #ffcc80 100%);
    color: var(--color-text-black);
    padding: 6px 12px;
    border-radius: 40px;
    font-size: 0.75rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 4px;

    i {
        font-size: 0.9rem;
    }

    .InfoIcon {
        margin-left: 6px;
        font-size: 1.2rem;
        opacity: 0.9;
        cursor: help;
        transition: opacity 0.2s;

        &:hover {
            opacity: 1;
        }
    }
}

.PlanLabel {
    font-size: 0.9375rem;
    font-weight: 700;
    margin-bottom: 12px;
    color: var(--color-text-blue);
    display: flex;
    align-items: center;
    gap: 8px;

    i {
        font-size: 1.125rem;
    }
}

.PlanDescription {
    font-size: 0.875rem;
    color: var(--color-text-gray-dark);
    margin-bottom: 8px;
    line-height: 1.5;
}

.PlanPrice {
    font-size: 2.125rem;
    font-weight: 700;
    color: var(--color-text-black);
    margin: 12px 0;
    line-height: 1;
}

.PriceInfo {
    font-size: 0.8125rem;
    color: var(--color-text-gray-dark);
    margin-bottom: 30px;
}

.FeatureList {
    list-style: none;
    padding: 0;
    margin: 0 0 30px 0;
    flex: 1;

    li {
        display: flex;
        align-items: flex-start;
        margin-bottom: 14px;
        font-size: 0.875rem;
        color: var(--color-text-black);
        line-height: 1.5;

        > span:last-child {
            display: flex;
            flex-direction: column;
        }
    }
}

.FeatureSubtext {
    font-size: 0.75rem;
    color: var(--color-text-gray-dark);
    margin-top: 4px;
    line-height: 1.4;
}

.FeatureHighlight {
    background: var(--color-bg);
    padding: 8px 12px;
    border-radius: 6px;
    margin: 0 -12px 14px -12px;

    span {
        color: var(--color-blue-dark);
        font-weight: 600;
    }
}

.FeatureIconCircle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    min-width: 24px;
    border-radius: 50%;
    background: var(--color-bg);
    color: var(--color-blue);
    margin-right: 12px;
    font-size: 0.9rem;
    flex-shrink: 0;

    i {
        line-height: 1;
    }
}

.PlanCta {
    margin-top: auto;
    padding-top: 20px;
}

.Upgrade-Button {
    width: 100%;
    padding: 12px 24px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.2s ease;

    &--primary {
        background: var(--color-blue);
        color: var(--color-text-white);
        border: none;

        &:hover {
            background: var(--color-blue-dark);
            transform: translateY(-1px);
        }
    }

    &--premium {
        background: var(--color-text-white);
        color: var(--color-text-black);
        border: 0.5px solid var(--color-blue-dark);
        font-weight: 700;

        &:hover {
            background: var(--color-bg);
            transform: translateY(-1px);
        }
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

:deep(.MenuDropdown) {
    margin: 12px 0 16px 0;
    position: relative;
}

:deep(.Price-Card--premium) {
    .MenuDropdown-Button {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.2);
        color: rgba(255, 255, 255, 0.9);

        &:hover {
            background: rgba(255, 255, 255, 0.15);
            border-color: rgba(255, 255, 255, 0.3);
        }
    }

    .MenuDropdown-Content {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .MenuDropdown-Item {
        background: rgba(255, 255, 255, 0.15);
        color: var(--color-text-black);
    }

    .MenuDropdown-InfoIcon {
        color: var(--color-text-gray-dark);

        &:hover i,
        &:focus i {
            color: var(--color-blue-dark);
        }
    }

    .MenuDropdown-InfoIcon {
        color: rgba(255, 255, 255, 0.7);

        &:hover i,
        &:focus i {
            color: rgba(255, 255, 255, 1);
        }
    }

    .MenuDropdown-Tooltip {
        background: var(--color-white);
        color: var(--color-text-blue);
        border: 0.5px solid var(--color-border-light);
    }
}
</style>
